import React from "react";

import { Text, TextDate } from "@performyard/py-components";

/**
 * Formats a date for readonly view in form cards
 * - For Date objects: renders using TextDate component
 * - For numbers (relative days): renders with context text based on type
 */
export const formatDateViewOnly = (
	date: Date | number | undefined,
	type?: "authors" | "signers" | "simple"
): React.ReactNode => {
	if (!date) return null;

	// For number values (relative days)
	if (typeof date === "number") {
		// Simple format - just show days
		if (type === "simple") {
			return (
				<Text size="paragraph-3" color="neutral-9">
					{date} days
				</Text>
			);
		}

		// Authors format - days from start date
		if (type === "authors") {
			return (
				<Text size="paragraph-3" color="neutral-9">
					{date} Days from <span className="font-semibold">Start Date</span>
				</Text>
			);
		}

		// Signers format - days from authors due date
		if (type === "signers") {
			return (
				<Text size="paragraph-3" color="neutral-9">
					{date} Days from <span className="font-semibold">Authors Due Date</span>
				</Text>
			);
		}

		// Default: just show the number of days
		return (
			<Text size="paragraph-3" color="neutral-9">
				{date} days
			</Text>
		);
	}

	// For Date objects, use TextDate component
	return <TextDate date={date} hasTime={true} dateSize="medium" />;
};
